var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',[_c('RabbeyTable4',{ref:"table",attrs:{"border":true,"stripe":true,"url":"/api/Calendar/getAll","request-config":_vm.requestConfig,"columns":_vm.mapColumns,"summary-method":_vm.getSummaries,"classTable":{
        'table-box': true,
        'card-base': true,
        'card-shadow--medium': false
      }}})],1),_c('deal-report-detail',{ref:"detail",attrs:{"whatsThisReportFor":"agenda"},on:{"getUpdatedData":_vm.refreshData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }